export default "__VITE_PUBLIC_ASSET__ecfd800a__"